import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {
  form: FormGroup;
  errorMessage
  submitted = false
  communityData
  currentUser
  constructor(private fb: FormBuilder, private authService: AuthservicesService, private router: Router) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
    this.getCommunityId(this.currentUser)

    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({

      welcomeMessage: ['', Validators.required],
      shortBio: ['', Validators.required]

    })
  }
  get f() {
    return this.form.controls;
  }

  getCommunityId(data) {
    let id
    if (data) {
      id = this.currentUser.id
    }
    this.authService.getCommunityByid(id).subscribe((res: any) => {
      this.communityData = res.data;
      this.fetchData();
    },
      error => {
        console.log(error)
      })
  }

  redirect() {
    this.router.navigate(['/user-registration/social-links'])
  }

  fetchData() {
    if (this.communityData) {
      let CONTROL = this.form.controls;
      for (let props in CONTROL) {
        CONTROL[props].patchValue(this.communityData[props]);
      }

    }

  }

  onSubmit() {

    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.signUpAboutus(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
      this.router.navigate(["/user-registration/custom-text-field"]);

    },
      error => {
        if (error.error.code == '401') {

        }
        this.authService.successMessage(error.error.message, 'error')
        console.log(error)
      })
  }

}
